import $ from 'cash-dom';

$(function () {
	const BusinessTypes = {
		init() {
			const self = this;

			self._hideSeparatorsIfNeeded();

			$(window).on('resize', function () {
				self._hideSeparatorsIfNeeded();
			});
		},

		_hideSeparatorsIfNeeded() {
			$('.col-actions .col-business-types').each(function (index, e) {
				const $businessTypes = $(e).find('.type-col');

				$businessTypes.each(function (i, businessType) {
					const current = businessType;
					const next = $businessTypes.get(i + 1);

					if (!current || !next) {
						return;
					}

					const $next = $(next);

					if (current.offsetTop === next.offsetTop) {
						$next.prev('.separator').css('display', 'block');
					} else {
						const $previousSibling = $next.prev('.separator');

						if ($previousSibling.length) {
							$previousSibling.css('display', 'none');
							$next.css('width', next.offsetWidth + 2 + 'px');
						}
					}
				});
			});
		},
	};

	BusinessTypes.init();
});
